define('audio/numbers',['require','exports','module','knockout','api-access','i18next','api-access','lodash'],function (require, exports, module) {
    var ko = require('knockout');
    var numbersApi = require('api-access').numbers;
    var i18n = require('i18next');
    var meetingsApi = require('api-access').meetings;
    var _ = require('lodash');

    function numbers() {
        var self = this;

        self.country = ko.observable();
        self.countries = ko.observableArray();
        self.accessCode = ko.observable();
        self.audioType = ko.observable();
        self.tollPhone = ko.observable();
        self.tollFreePhone = ko.observable();
        self.alternateNumbersCountries = ko.observableArray();
        self.alternateNumberPresent = ko.observable();

        self.phonesByCountry = {};

        // E.g. 'US' -> 'United States'
        self.fullCountryName = function (code) {
            return i18n.t('countries.' + code);
        };

        self.country.subscribe(function (country) {
            self.phoneForCountry(country);
        });

        self.phoneForCountry = function (country) {
            self.tollPhone('');
            self.tollFreePhone('');
            self.alternateNumberPresent('');

            if (!self.phonesByCountry[country]) {
                return;
            }

            _.forEach(self.phonesByCountry[country], function (number) {
                if (number.tollFree) {
                    self.tollFreePhone(number.displayNumber);
                }
                if (!number.tollFree) {
                    self.tollPhone(number.displayNumber);
                }
            });

            self.alternateNumberPresent('true');
        };

        // Toll and Toll-Free numbers are returned as separate entities.
        // Storing them by country for quicker retrieval later.
        self.mapPhonesByCountry = function (allNumbers) {
            if (!allNumbers) {
                return;
            }

            _.forEach(allNumbers, function (number) {
                var countryName = self.fullCountryName(number.country);
                if (!self.phonesByCountry[countryName]) {
                    self.phonesByCountry[countryName] = [];
                }
                self.phonesByCountry[countryName].push(number);
            });

            self.alternateNumbersCountries = _.keys(self.phonesByCountry);
        };

        self.defaultCountry = function (countryCode) {
            self.country(self.fullCountryName(countryCode));
            self.phoneForCountry(self.fullCountryName(countryCode));
        };

        self.getMeeting = function (meetingId) {
            return meetingsApi.byIdNoAuth(meetingId, true)
                .then(function (data) {
                    if (data.audio.phoneNumbers) {
                        // set audio type
                        self.audioType(data.audio.audioType);
                        var names = [];

                        _.forEach(data.audio.phoneNumbers, function (number) {
                            var countryName = self.fullCountryName(number.country);
                            if (!(_.contains(names, countryName))) {
                                names.push(countryName);
                            }
                        });

                        self.countries = names.sort();
                        self.defaultCountry(self.countries[0]);
                    }
                });
        };

        self.alternateNumbers = function (meetingId) {
            return numbersApi.alternates(meetingId)
                .then(function (data) {
                    self.audioType(data.audioType);
                    if (data.phoneNumbers) {
                        self.mapPhonesByCountry(data.phoneNumbers);
                        self.accessCode(data.accessCode);
                    }
                })
                .fail(function () {
                    window.location = '/pageNotFound';
                });
        };

        self.activate = function (meetingId) {
            var p1 = self.getMeeting(meetingId);
            var p2 = self.alternateNumbers(meetingId);
            return Promise.all([p1, p2]);
        };

        self.multipleNumbers = function () {
            return self.tollPhone() && self.tollFreePhone();
        };

        self.questionsText = function () {
            return i18n.t('alternateNumber.aside.questions.text',
                '<a class="btn-link" href="' + i18n.t('web-urls.urls.g2m.support') + '">',
                '</a>',
                '<a class="btn-link" href="' + i18n.t('web-urls.urls.g2m.twitter') + '">',
                '</a>');
        };
    }

    module.exports = numbers;
});

